import { createPortal } from 'react-dom';
import { fontStack } from '../styles/shared';

export default function ConfirmModal({ open, title, message, confirmLabel, cancelLabel, danger, onConfirm, onCancel }) {
    if (!open) return null;
    return createPortal(
        <div onClick={onCancel} style={{
            position: 'fixed', inset: 0, zIndex: 100000,
            background: 'rgba(0,0,0,0.45)', display: 'flex',
            alignItems: 'center', justifyContent: 'center', padding: '24px',
        }}>
            <div onClick={e => e.stopPropagation()} style={{
                background: 'var(--card-bg)', borderRadius: '14px',
                padding: '28px 24px 20px', maxWidth: '380px', width: '100%',
                boxShadow: '0 16px 48px rgba(0,0,0,0.18)',
                fontFamily: fontStack,
            }}>
                {title && (
                    <h3 style={{ fontSize: '17px', fontWeight: 700, color: 'var(--text)', marginBottom: '8px' }}>
                        {title}
                    </h3>
                )}
                <p style={{ fontSize: '14px', color: 'var(--text-muted)', lineHeight: 1.6, marginBottom: '24px' }}>
                    {message}
                </p>
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <button onClick={onCancel} style={{
                        padding: '10px 18px', borderRadius: '8px', fontSize: '14px',
                        fontWeight: 600, border: '1px solid var(--border)',
                        background: 'var(--surface)', color: 'var(--text)',
                        cursor: 'pointer', fontFamily: fontStack,
                    }}>
                        {cancelLabel || 'Cancel'}
                    </button>
                    <button onClick={onConfirm} style={{
                        padding: '10px 18px', borderRadius: '8px', fontSize: '14px',
                        fontWeight: 600, border: 'none',
                        background: danger ? 'var(--error, #ef4444)' : 'var(--accent)',
                        color: '#fff', cursor: 'pointer', fontFamily: fontStack,
                    }}>
                        {confirmLabel || 'Confirm'}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}
